import { BaseMapper } from '@shared/data';
import { ReportClaimBodyModel } from '../../../../../core/interface/claims/report-claim-body-model';
import { ReportClaimResponseModel } from '../../../../../core/interface/claims/report-claim-response-model';
import { ReportClaimBodyDto } from '../../../interface/dto/features/report-claim/report-claim-request-dto';
import { ReportClaimResponseDto } from '../../../interface/dto/features/report-claim/report-claim-response-dto';

export class ReportClaimMapper extends BaseMapper<ReportClaimResponseModel, ReportClaimResponseDto> {
    public mapDtoToModel(dto: ReportClaimResponseDto): ReportClaimResponseModel {
        return {
            id: dto.id,
            medicalDocumentationId: dto.medicalDocumentationId,
            submittedAt: this.stringDateToDayjs(dto.submittedAt),
            status: dto.status,
            insurance: dto.insurance,
            externalId: dto.externalId,
            claimNumber: dto.claimNumber,
            error: dto.error,
            createdAt: this.stringDateToDayjs(dto.createdAt),
            updatedAt: this.stringDateToDayjs(dto.updatedAt),
        };
    }

    override mapModelToDto(model: ReportClaimResponseModel): ReportClaimResponseDto {
        return {
            id: model.id,
            medicalDocumentationId: model.medicalDocumentationId,
            submittedAt: this.dayjsFormatForDto(model.submittedAt),
            status: model.status,
            insurance: model.insurance,
            externalId: model.externalId,
            claimNumber: model.claimNumber,
            error: model.error,
            createdAt: this.dayjsFormatForDto(model.createdAt),
            updatedAt: this.dayjsFormatForDto(model.updatedAt),
        };
    }

    public mapReportClaimBodyDtoToModel(dto: ReportClaimBodyDto): ReportClaimBodyModel {
        return {
            medicalDocumentationId: dto.medicalDocumentationId,
            customerTaxNumber: dto.customerTaxNumber,
            customerComment: dto.customerComment,
        };
    }

    public mapReportClaimBodyModelToDto(model: ReportClaimBodyModel): ReportClaimBodyDto {
        return {
            medicalDocumentationId: model.medicalDocumentationId,
            customerTaxNumber: model.customerTaxNumber,
            customerComment: model.customerComment,
        };
    }
}
